import { render, staticRenderFns } from "./login-form.vue?vue&type=template&id=19439a90&lang=html&"
import script from "./login-form.vue?vue&type=script&lang=js&"
export * from "./login-form.vue?vue&type=script&lang=js&"
import style0 from "./login-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19439a90')) {
      api.createRecord('19439a90', component.options)
    } else {
      api.reload('19439a90', component.options)
    }
    module.hot.accept("./login-form.vue?vue&type=template&id=19439a90&lang=html&", function () {
      api.rerender('19439a90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/login-form.vue"
export default component.exports